module.exports = __webpack_public_path__ + "static/img/kehu-01.4970dde7.png";